module.exports = __webpack_public_path__ + "static/media/meteringbanner@2x.a6765119.png";